module.exports = __webpack_public_path__ + "img/botonWhatsapp.d8f8274c.jpg";